import { EmptyState } from '@chopchop-se/ui';
import { HardHat } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/PageHeader';

export function ExceptionsPage(): ReactNode {
  const { t } = useTranslation('shell');
  return (
    <>
      <PageHeader title={t('exceptions.title')} subtitle={t('exceptions.subtitle')} />
      <EmptyState
        icon={<HardHat />}
        title={t('underConstruction.title')}
        description={t('underConstruction.description')}
      />
    </>
  );
}
